import { Order } from '../../interfaces/order';
import { TicketPackageInstance } from '../../interfaces/ticket-package-instance';
import { ApiDeleteRequest } from './api-delete-request';
import { ApiParameters } from './api-parameters';

export class PackageDeleteReservationRequest extends ApiDeleteRequest
{
    public constructor(order: Order, ticketPackage: TicketPackageInstance, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('orderid', order.Id)
            .addQueryParameter('ticketPackageInstanceId', ticketPackage.Id)

        super('packagereservation', parameters, null, null, webapiBasepath);
    }
}

